export const statisticPath = 'statistic';
